<template>
  <div>
    <question-renderer
      :question="src"
      :indicator="indicator"
    ></question-renderer>

    <!-- <v-divider class="my-3"></v-divider> -->
    <div class="wysiwyg-content mt-n4" id="choices-block" ref="choicesBlock">
      <template v-for="(item, idx) in src.choices">
        <div class="d-flex align-end" :key="`choice_${idx}`">
          <div class="grow" style="max-width: 100%">
            <v-checkbox
              v-model="answer"
              :value="`${item._id}`"
              hide-details
              :readonly="readOnly"
              :ripple="!readOnly"
            >
              <template v-slot:label>
                <div v-html="item.text"></div>
              </template>
            </v-checkbox>
          </div>
          <div class="shrink">
            <v-icon small v-if="showCorrectAnswer" :color="setColor(item._id)"
              >far
              {{
                setColor(item._id) == "success" ? "fa-check" : "fa-times"
              }}</v-icon
            >
          </div>
        </div>
      </template>
    </div>

    <v-expand-transition>
      <div
        v-if="
          showCorrectAnswer &&
          correctAnswer.note != null &&
          correctAnswer.note != ''
        "
        class="mt-4"
      >
        <!-- <v-divider class="my-3"></v-divider> -->
        <v-alert text type="info" :icon="false">
          <div class="subtitle-1 font-weight-bold">
            <v-icon color="info" left>far fa-info-circle</v-icon>เพิ่มเติม
          </div>
          <v-divider class="my-3 info" style="opacity: 0.2"></v-divider>
          <div v-html="correctAnswer.note"></div>
        </v-alert>
      </div>
    </v-expand-transition>

    <v-overlay :value="overlay">
      <pinch-zoom v-bind:properties="myProperties">
        <img :src="imgPinch" />
      </pinch-zoom>
      <v-btn class="ma-2 btn-close" fab dark small @click="overlay = false">
        <v-icon>far fa-times</v-icon>
      </v-btn>
    </v-overlay>
  </div>
</template>

<script>
import EventBus from "@/event-bus";
import PinchZoom from "vue-pinch-zoom";
import QuestionRenderer from "@/components/QuestionRenderer.vue";
export default {
  name: "MultipleChoiceExam",
  props: ["src", "userAnswer", "correctAnswer", "indicator"],
  data: () => ({
    answer: [],
    overlay: false,
    myProperties: {
      overflow: "visible",
    },
    imgPinch: null,
  }),
  watch: {
    answer(val) {
      const data = {
        answer: val,
      };
      this.$emit("interact", data);
    },
  },
  computed: {
    showCorrectAnswer() {
      if (
        this.correctAnswer != null &&
        this.correctAnswer.correct.length != 0
      ) {
        this.$nextTick(() => {
          if (this.$store.state.showCorrectAnswer == false) {
            this.$vuetify.goTo("#choices-block");
          }
        });
        return true;
      }
      return false;
    },
    readOnly() {
      return this.$store.state.readOnly;
    },
  },
  mounted() {
    this.answer = [];
    this.init();

    this.$nextTick().then(() => {
      // find img
      let imgs = this.$refs.choicesBlock.querySelectorAll("img");
      for (let img of imgs) {
        // img.style.maxWidth = "100%";
        // img.style.height = "auto";
        img.addEventListener("click", (e) => {
          this.showOverlay(e);
        });
      }

      let links = this.$refs.choicesBlock.querySelectorAll("a");
      for (let link of links) {
        // img.style.maxWidth = "100%";
        // img.style.height = "auto";
        link.addEventListener("click", (e) => {
          e.preventDefault();
          EventBus.$emit("internalBrowser", e.target.href);
        });
      }
    });
  },
  components: {
    QuestionRenderer,
    PinchZoom,
  },
  methods: {
    showOverlay(e) {
      this.imgPinch = e.target.src;
      this.overlay = true;
    },
    setColor(value) {
      if (this.showCorrectAnswer === true) {
        if (this.correctAnswer.correct.findIndex((x) => x == value) != -1) {
          return "success";
        } else {
          return "error";
        }
      }
      return "primary";
    },
    setColorText(value) {
      if (this.showCorrectAnswer === true) {
        if (this.correctAnswer.correct.findIndex((x) => x == value) != -1) {
          return ["success--text"];
        } else {
          return ["error--text"];
        }
      }
      return [""];
    },
    init() {
      // console.log("init multiple q", this.src);
      // console.log(this.userAnswer);

      if (this.userAnswer != null) {
        this.answer = this.userAnswer;
      }
    },
    getAnswer() {
      return this.answer;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .label-slot {
  &.success--text {
  }

  &.error--text {
  }
}

#choices-block ::v-deep * img {
  max-width: 100%;
}

::v-deep .btn-close {
  position: fixed;
  top: 0px;
  right: 0px;
}
</style>